<template>
  <oxd-sheet :gutters="false" class="orangehrm-dashboard-widget">
    <div class="orangehrm-dashboard-widget-header">
      <div class="orangehrm-dashboard-widget-name">
        <oxd-icon
          :name="icon"
          :type="iconType"
          class="orangehrm-dashboard-widget-icon"
        ></oxd-icon>
        <oxd-text tag="p">
          {{ title }}
        </oxd-text>
      </div>
      <slot name="action"></slot>
    </div>
    <oxd-divider />
    <oxd-loading-spinner
      v-if="loading"
      class="orangehrm-dashboard-widget-loader"
    />
    <div v-else ref="widgetRef" :class="widgetBodyClasses">
      <div
        v-for="item in items?.data"
        :key="item.id"
        style="display: flex; gap: 5px; justify-content: space-between; border-bottom: 1px solid #e0e0e0; padding: 10px 0;"
      >
        <oxd-text
          tag="p"
          class="orangehrm-leave-card-emp-name orangehrm-text oxd-text--p"
        >
          {{ item.name }}
        </oxd-text>
        <oxd-text
          v-if="item?.startDate"
          tag="p"
          class="orangehrm-leave-card-emp-name orangehrm-text oxd-text--p"
        >
          from {{ item.startDate }}
        </oxd-text>
        <oxd-text
          v-if="item?.endDate"
          tag="p"
          class="orangehrm-leave-card-emp-name orangehrm-text oxd-text--p"
        >
          to {{ item.endDate }}
        </oxd-text>
        <!--
        <oxd-text tag="label" class="orangehrm-text oxd-text--p">
          {{ item.jobTitle }}
        </oxd-text>
        -->
      </div>
      <slot></slot>
      <div v-if="empty" class="orangehrm-dashboard-widget-body-nocontent">
        <img
          :src="defaultPic"
          alt="No Content"
          class="orangehrm-dashboard-widget-img"
        />
        <oxd-text tag="p">
          {{ emptyText || $t('dashboard.not_available') }}
        </oxd-text>
      </div>
    </div>
  </oxd-sheet>
</template>

<script>
import {computed, ref} from 'vue';
import Icon from '@ohrm/oxd/core/components/Icon/Icon';
import Sheet from '@ohrm/oxd/core/components/Sheet/Sheet';
import Spinner from '@ohrm/oxd/core/components/Loader/Spinner';
import {APIService} from '@/core/util/services/api.service';
import usePaginate from '@/core/util/composable/usePaginate';

export default {
  name: 'BackupsResponsabilitiesWidget',
  components: {
    'oxd-sheet': Sheet,
    'oxd-icon': Icon,
    'oxd-loading-spinner': Spinner,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    empty: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: null,
    },
    iconType: {
      type: String,
      default: undefined,
    },
  },
  setup() {
    const widgetRef = ref();
    const defaultPic = `${window.appGlobal.baseUrl}/../images/dashboard_empty_widget_watermark.png`;

    const widgetBodyClasses = computed(() => ({
      'orangehrm-dashboard-widget-body': true,
      '--scroll-visible':
        widgetRef.value?.scrollHeight > widgetRef.value?.clientHeight,
    }));

    const employeeBackupAssignNormalizer = data => {
      return data.map(item => {
        return {
          id: item.id,
          name: item.name,
          jobTitle: item.jobTitle,
          startDate: item.startDate,
          endDate: item.endDate,
        };
      });
    };

    const http = new APIService(
      window.appGlobal.baseUrl,
      `api/v2/pim/employees/${window.appGlobal.user.id}/backups?type=responsabilities`,
    );

    const {
      showPaginator,
      currentPage,
      total,
      pages,
      pageSize,
      response,
      isLoading,
      execQuery,
    } = usePaginate(http, {
      normalizer: employeeBackupAssignNormalizer,
      toastNoRecords: false,
    });

    return {
      widgetRef,
      defaultPic,
      widgetBodyClasses,
      http,
      showPaginator,
      currentPage,
      isLoading,
      total,
      pages,
      pageSize,
      execQuery,
      items: response,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../base-widget.scss';
@import '../employee-on-leave-widget.scss';
.text-12 {
  font-size: 12px;
}
</style>
